var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", [
    _c(
      "div",
      { staticClass: "sub_footer" },
      [
        _c(
          "v-row",
          { staticClass: "pt-5 pb-6", attrs: { justify: "space-between" } },
          [
            _c(
              "v-col",
              {
                staticClass: "pb-0 pt-1",
                attrs: { cols: "12", md: "auto", sm: "12" },
              },
              [
                _c("p", { staticClass: "text-center" }, [
                  _c("span", { staticClass: "text-uppercase" }, [
                    _vm._v(_vm._s(_vm.name)),
                  ]),
                  _vm._v(" © - v" + _vm._s(_vm.appVersion)),
                ]),
              ]
            ),
            _c(
              "v-col",
              {
                staticClass: "pb-0 pt-1",
                attrs: { cols: "12", md: "auto", sm: "12" },
              },
              [
                _c("p", { staticClass: "text-center" }, [
                  _vm._v("DESIGN BY INTEGRASOFT - 2022"),
                ]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }